import React, { HTMLAttributes } from 'react';

import classes from './PageTitle.scss';

type Props = {
    title: string;
    variant?: 'normal' | 'with-subheading' | 'slim';
    testId?: string;
} & HTMLAttributes<any>;

export function PageTitle(props: Props) {
    const { title, testId, ...rest } = props;
    return (
        <h1 className={classes.pageTitle} data-test-id={props.testId} {...rest} data-variant={props.variant}>
            {title}
            {props.children}
        </h1>
    );
}

PageTitle.defaultProps = { variant: 'normal' };
